import { Component } from '@angular/core';
import { GlobalServiceProvider} from "../../providers/global.service";

/**
 * Generated class for the HeaderbarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'majime-headerbar',
  templateUrl: 'majime-headerbar.html'
})
export class MajimeHeaderbarComponent {

  text: string;

  constructor(public global:GlobalServiceProvider) {
    console.log('Hello MajimeHeaderbarComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/headerbar/majime-headerbar.ts